var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column",
    class: {
      last: _vm.isLast
    }
  }, [_c('div', {
    staticClass: "location-name"
  }, [_c('div', {
    staticClass: "location-name-text"
  }, [_vm._v(" " + _vm._s(_vm.eventFlowLocation.name) + " ")])]), _c('div', {
    staticClass: "d-flex location-column",
    class: {
      'location-column-background': _vm.index % 2 === 1
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }